import {
  AssetAuditLogDetails,
  AssignAdHocTaskAuditLog,
  AssignPersonnelAuditLog,
  AttendanceTakingAuditLog,
  AuditLog,
  AuditLogAssetItemDetails,
  AuditLogChatConfiguration,
  AuditLogChatNotification,
  AuditLogCreateNewChatChannel,
  AuditLogDetailsType,
  AuditLogEditScheduleShiftsDetails,
  AuditLogEditUserItem,
  AuditLogEditUsersDetails,
  AuditLogEmailNotification,
  AuditLogFieldDefinition,
  AuditLogManualCloseShiftDetails,
  AuditLogModule,
  AuditLogOTPersonnel,
  AuditLogRenameTeamDetails,
  AuditLogRenameTeamItem,
  AuditLogRosterDetails,
  AuditLogScheduleShiftItem,
  AuditLogSectorDetails,
  AuditLogSectorGroupingDetails,
  AuditLogShiftResourceActionDetails,
  AuditLogShiftResourceConfigurationDetails,
  AuditLogSubTask,
  AuditLogSubTaskElement,
  AuditLogTaskApprovalRule,
  AuditLogType,
  AuditLogVesselActivityActionDetails,
  AuthenticationLogInAuditLog,
  ChatConfigurationsFields,
  CloseVesselAuditLog,
  ConfigurationAuditLog,
  DataSourcesDetails,
  DuplicateTaskAuditLog,
  EmailNotificationTypeEnum,
  HandoverRemarksAuditLog,
  HotoTemplateAuditLog,
  PendingForApprovalNAAuditLog,
  PersonnelAuditLog,
  ReportAuditLog,
  SaveAsDraftTaskAuditLog,
  TaskAssignSubTask,
  TaskDetails,
  VesselActivityConfigurationAuditLog,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import {
  AssetAuditLogDetailsDTO,
  AssignAdHocTaskAuditLogDTO,
  AssignPersonnelAuditLogDTO,
  AttendanceTakingAuditLogDTO,
  AuditLogAssetItemDetailsDTO,
  AuditLogChatConfigurationDTO,
  AuditLogChatNotificationDTO,
  AuditLogCreateNewChatChannelDTO,
  AuditLogDTO,
  AuditLogEditScheduleShiftsDTO,
  AuditLogEditUsersDTO,
  AuditLogEmailNotificationDTO,
  AuditLogFieldDefinitionDTO,
  AuditLogManualCloseShiftDTO,
  AuditLogOTPersonnelDTO,
  AuditLogRenameTeamDTO,
  AuditLogRenameTeamItemDTO,
  AuditLogRosterDetailsDTO,
  AuditLogScheduleShiftItemDTO,
  AuditLogSectorDetailsDTO,
  AuditLogSectorGroupingDetailsDTO,
  AuditLogShiftResourceActionnDTO,
  AuditLogShiftResourceConfigurationDTO,
  AuditLogSubTaskDTO,
  AuditLogSubTaskElementDTO,
  AuditLogTaskApprovalRuleDTO,
  AuditLogVesselActivityActionDTO,
  AuthenticationLogInAuditLogDTO,
  ChangeStatusAssetAuditDTO,
  CloseVesselAuditLogDTO,
  ConfigurationAuditLogDTO,
  DataSourcesDetailsDTO,
  DuplicateTaskAuditLogDTO,
  HandoverRemarksAuditLogDTO,
  HotoTemplateAuditLogDTO,
  PendingForApprovalNAAuditLogDTO,
  PersonnelAuditLogDTO,
  ReportAuditLogDTO,
  SaveAsDraftTaskAuditLogDTO,
  TaskAssignSubTaskDTO,
  TaskDetailsDTO,
  VesselActivityConfigurationAuditLogDTO,
} from '../dtos';

export class ConfigurationAuditLogMapper {
  configurationAuditLogToDomain(
    dto: PaginatedResponse<ConfigurationAuditLogDTO>
  ): PaginatedResponse<ConfigurationAuditLog> {
    return {
      data: dto.data.map(dtoItem => ({
        id: dtoItem.id,
        lastUpdatedOn: dtoItem.lastUpdatedOn,
        lastUpdatedBy: dtoItem.lastUpdatedBy,
        module: dtoItem.module,
        event: dtoItem.event,
        taskName: dtoItem.taskName ?? null,
      })),
      page: dto.page,
      size: dto.size,
      totalElements: dto.totalElements,
      totalPages: dto.totalPages,
    };
  }

  configurationAuditLogItemToDomain(dto: AuditLogDTO): AuditLog {
    const { module, details, event, lastUpdatedBy } = dto;
    const { roles, username } = lastUpdatedBy;
    let newData: AuditLogDetailsType = {} as AuditLogDetailsType;
    let oldData: AuditLogDetailsType = {} as AuditLogDetailsType;

    switch (module) {
      case AuditLogModule.CMS_DATASOURCE:
        newData = this._configurationDataSourcesAuditLogToDomain(
          details.newData as DataSourcesDetailsDTO
        );
        oldData = this._configurationDataSourcesAuditLogToDomain(
          details.oldData as DataSourcesDetailsDTO
        );
        break;
      case AuditLogModule.TASK:
        switch (event) {
          case AuditLogType.CREATE_TASK:
          case AuditLogType.EDIT_TASK:
          case AuditLogType.ACTIVE_TASK:
          case AuditLogType.INACTIVE_TASK:
            newData = this._configurationTaskAuditLogToDomain(
              details.newData as TaskDetailsDTO
            );
            oldData = this._configurationTaskAuditLogToDomain(
              details.oldData as TaskDetailsDTO
            );
            break;
          case AuditLogType.CREATE_SUBTASK:
          case AuditLogType.EDIT_SUBTASK:
          case AuditLogType.ACTIVE_SUBTASK:
          case AuditLogType.INACTIVE_SUBTASK:
            newData = this._configurationSubTaskLogToDomain(
              details.newData as AuditLogSubTaskDTO
            );
            oldData = this._configurationSubTaskLogToDomain(
              details.oldData as AuditLogSubTaskDTO
            );
            break;
        }
        break;
      case AuditLogModule.SECTORS:
        switch (event) {
          case AuditLogType.CREATE_SECTOR:
          case AuditLogType.EDIT_SECTOR:
          case AuditLogType.ACTIVE_SECTOR:
          case AuditLogType.INACTIVE_SECTOR:
            newData = this._configurationSectorAuditLogToDomain(
              details.newData as AuditLogSectorDetailsDTO
            );
            oldData = this._configurationSectorAuditLogToDomain(
              details.oldData as AuditLogSectorDetailsDTO
            );
            break;
          case AuditLogType.ADD_GROUPING:
          case AuditLogType.EDIT_GROUPING:
          case AuditLogType.DELETE_GROUPING:
            newData = this._configurationGroupingAuditLogToDomain(
              details.newData as AuditLogSectorGroupingDetailsDTO
            );
            oldData = this._configurationGroupingAuditLogToDomain(
              details.oldData as AuditLogSectorGroupingDetailsDTO
            );
            break;
        }
        break;
      case AuditLogModule.CHAT:
        switch (event) {
          case AuditLogType.CREATE_NEW_CHANNEL_CHAT:
          case AuditLogType.SWITCH_ARCHIVED_CHAT:
            newData = this._configurationCreateNewChatChannelLogToDomain(
              details.newData as AuditLogCreateNewChatChannelDTO
            );
            oldData = this._configurationCreateNewChatChannelLogToDomain(
              details.oldData as AuditLogCreateNewChatChannelDTO
            );
            break;
          case AuditLogType.CHAT_CONFIGURATIONS:
            newData = this._configurationChatConfigurationsLogToDomain(
              details.newData as AuditLogChatConfigurationDTO
            );
            oldData = this._configurationChatConfigurationsLogToDomain(
              details.oldData as AuditLogChatConfigurationDTO
            );
            break;
        }
        break;
      case AuditLogModule.ROSTER:
        newData = this._configurationRosterLogToDomain(
          details.newData as AuditLogRosterDetailsDTO
        );
        oldData = this._configurationRosterLogToDomain(
          details.oldData as AuditLogRosterDetailsDTO
        );
        break;
      case AuditLogModule.CMS_ASSET:
        switch (event) {
          case AuditLogType.ASSETS_CREATE:
          case AuditLogType.ASSETS_UPDATE:
            newData = this._configurationAssetsAuditLogToDomain(
              details.newData as AssetAuditLogDetailsDTO
            );
            oldData = this._configurationAssetsAuditLogToDomain(
              details.oldData as AssetAuditLogDetailsDTO
            );
            break;
          case AuditLogType.ASSETS_ACTIVE:
          case AuditLogType.ASSETS_INACTIVE:
            newData = this._configurationChangeStatusAssetAuditLogToDomain(
              details.newData as ChangeStatusAssetAuditDTO
            );
            oldData = this._configurationChangeStatusAssetAuditLogToDomain(
              details.oldData as ChangeStatusAssetAuditDTO
            );
            break;
          case AuditLogType.ASSETS_ITEM_CREATE:
          case AuditLogType.ASSETS_ITEM_UPDATE:
          case AuditLogType.ASSETS_ITEM_DELETE:
            newData = this._configurationAssetItemLogToDomain(
              details.newData as AuditLogAssetItemDetailsDTO
            );
            oldData = this._configurationAssetItemLogToDomain(
              details.oldData as AuditLogAssetItemDetailsDTO
            );
            break;
        }
        break;
      case AuditLogModule.ALERTS_NOTIFICATIONS:
        switch (event) {
          case AuditLogType.ADD_EMAIL_NOTIFICATION:
          case AuditLogType.EDIT_EMAIL_NOTIFICATION:
          case AuditLogType.DELETE_EMAIL_NOTIFICATION:
            newData = this._configurationEmailNotificationLogToDomain(
              details.newData as AuditLogEmailNotificationDTO
            );
            oldData = this._configurationEmailNotificationLogToDomain(
              details.oldData as AuditLogEmailNotificationDTO
            );
            break;

          case AuditLogType.ADD_TASK_APPROVAL_RULES:
          case AuditLogType.EDIT_TASK_APPROVAL_RULES:
          case AuditLogType.DELETE_TASK_APPROVAL_RULES:
            newData = this._configurationApprovalRuleLogToDomain(
              details.newData as AuditLogTaskApprovalRuleDTO
            );
            oldData = this._configurationApprovalRuleLogToDomain(
              details.oldData as AuditLogTaskApprovalRuleDTO
            );
            break;
          case AuditLogType.ADD_CHAT_NOTIFICATION:
          case AuditLogType.EDIT_CHAT_NOTIFICATION:
          case AuditLogType.DELETE_CHAT_NOTIFICATION:
            newData = this._configurationChatNotificationLogToDomain(
              details.newData as AuditLogChatNotificationDTO
            );
            oldData = this._configurationChatNotificationLogToDomain(
              details.oldData as AuditLogChatNotificationDTO
            );
            break;
        }
        break;
      case AuditLogModule.USER_AUTHENTICATION:
        newData = this._authenticationLogInToDomain(
          details.newData as AuthenticationLogInAuditLogDTO,
          roles,
          username
        );
        oldData = this._authenticationLogInToDomain(
          details.oldData as AuthenticationLogInAuditLogDTO,
          roles,
          username
        );
        break;
      case AuditLogModule.HANDOVER_LOGS:
        newData = this._handoverRemarksLogToDomain(
          details.newData as HandoverRemarksAuditLogDTO
        );
        oldData = this._handoverRemarksLogToDomain(
          details.oldData as HandoverRemarksAuditLogDTO
        );
        break;
      case AuditLogModule.ATTENDANCE_TAKING:
        newData = this._attendanceTakingLogToDomain(
          details.newData as AttendanceTakingAuditLogDTO
        );
        oldData = this._attendanceTakingLogToDomain(
          details.oldData as AttendanceTakingAuditLogDTO
        );
        break;
      case AuditLogModule.TASK_ASSIGNMENTS:
        switch (event) {
          case AuditLogType.ASSIGN_PERSONNEL:
          case AuditLogType.UNASSIGN_PERSONNEL:
            newData = this._userAssignPersonnelToDomain(
              details.newData as AssignPersonnelAuditLogDTO
            );
            oldData = this._userAssignPersonnelToDomain(
              details.oldData as AssignPersonnelAuditLogDTO
            );
            break;
          case AuditLogType.SAVE_AS_DRAFT_TASK:
          case AuditLogType.OPEN_TASK:
          case AuditLogType.TASK_COMPLETED:
          case AuditLogType.TASK_COMPLETED_NA:
          case AuditLogType.PENDING_FOR_APPROVAL:
          case AuditLogType.PENDING_FOR_APPROVAL_NA:
            newData = this._userSaveAsDraftTaskLogToDomain(
              details.newData as SaveAsDraftTaskAuditLogDTO
            );
            oldData = this._userSaveAsDraftTaskLogToDomain(
              details.oldData as SaveAsDraftTaskAuditLogDTO
            );
            break;
          case AuditLogType.DUPLICATE_TASK:
          case AuditLogType.DELETE_DUPLICATED_TASK:
          case AuditLogType.TASK_REJECTED:
            newData = this._duplicateTaskLogToDomain(
              details.newData as DuplicateTaskAuditLogDTO
            );
            oldData = this._duplicateTaskLogToDomain(
              details.oldData as DuplicateTaskAuditLogDTO
            );
            break;
          case AuditLogType.ASSIGN_AD_HOC_TASK:
            newData = this._assignAdHocTaskLogToDomain(
              details.newData as AssignAdHocTaskAuditLogDTO
            );
            oldData = this._assignAdHocTaskLogToDomain(
              details.oldData as AssignAdHocTaskAuditLogDTO
            );
            break;
          case AuditLogType.UNDO_MARKED_NOT_APPLICABLE:
          case AuditLogType.TASK_REJECTED_NA:
            newData = this._pendingForApprovalLogToDomain(
              details.newData as PendingForApprovalNAAuditLogDTO
            );
            oldData = this._pendingForApprovalLogToDomain(
              details.oldData as PendingForApprovalNAAuditLogDTO
            );
            break;
        }
        break;
      case AuditLogModule.OT_PERSONNEL:
        newData = this._otPersonnelToDomain(
          details.newData as AuditLogOTPersonnelDTO
        );
        oldData = this._otPersonnelToDomain(
          details.oldData as AuditLogOTPersonnelDTO
        );
        break;

      case AuditLogModule.REPORTS:
        newData = this._reportAuditLogToDomain(
          details.newData as ReportAuditLogDTO
        );
        oldData = this._reportAuditLogToDomain(
          details.oldData as ReportAuditLogDTO
        );
        break;

      case AuditLogModule.VESSEL_LOGS:
        switch (event) {
          case AuditLogType.CLOSE_VESSEL:
            newData = this._closeVesselToDomain(
              details.newData as CloseVesselAuditLogDTO
            );
            oldData = this._closeVesselToDomain(
              details.oldData as CloseVesselAuditLogDTO
            );
            break;
        }
        break;
      case AuditLogModule.HOTO_CONFIGURATION:
        switch (event) {
          case AuditLogType.CREATE_HOTO_TEMPLATE:
          case AuditLogType.EDIT_HOTO_TEMPLATE:
          case AuditLogType.ACTIVE_HOTO_TEMPLATE:
          case AuditLogType.INACTIVE_HOTO_TEMPLATE:
            newData = this._hotoTemplateToDomain(
              details.newData as HotoTemplateAuditLogDTO
            );
            oldData = this._hotoTemplateToDomain(
              details.oldData as HotoTemplateAuditLogDTO
            );
            break;
        }
        break;
      case AuditLogModule.HOTO_MANAGEMENT:
      case AuditLogModule.CMS_HOTO_MANAGEMENT:
        // The logged form snapshot is read as-is by the HOTO audit log view
        newData = details.newData as unknown as AuditLogDetailsType;
        oldData = details.oldData as unknown as AuditLogDetailsType;
        break;
      case AuditLogModule.VESSEL_ACTIVITY_CONFIGURATION:
      case AuditLogModule.CMS_VESSEL_ACTIVITY_MANAGEMENT:
        switch (event) {
          case AuditLogType.CREATE_VESSEL_ACTIVITY_CONFIG:
          case AuditLogType.EDIT_VESSEL_ACTIVITY_CONFIG:
          case AuditLogType.ACTIVE_VESSEL_ACTIVITY_CONFIG:
          case AuditLogType.INACTIVE_VESSEL_ACTIVITY_CONFIG:
            newData = this._vesselActivityConfigurationToDomain(
              details.newData as VesselActivityConfigurationAuditLogDTO
            );
            oldData = this._vesselActivityConfigurationToDomain(
              details.oldData as VesselActivityConfigurationAuditLogDTO
            );
            break;
          case AuditLogType.ADD_VESSEL_ACTIVITY:
          case AuditLogType.EDIT_VESSEL_ACTIVITY:
          case AuditLogType.DELETE_VESSEL_ACTIVITY:
            newData = this._vesselActivityActionToDomain(
              details.newData as AuditLogVesselActivityActionDTO
            );
            oldData = this._vesselActivityActionToDomain(
              details.oldData as AuditLogVesselActivityActionDTO
            );
            break;
        }
        break;
      case AuditLogModule.SHIFT_RESOURCE_CONFIGURATION:
      case AuditLogModule.CMS_SHIFT_RESOURCE_MANAGEMENT:
        switch (event) {
          case AuditLogType.CREATE_SHIFT_RESOURCE_CONFIG:
          case AuditLogType.EDIT_SHIFT_RESOURCE_CONFIG:
          case AuditLogType.ACTIVE_SHIFT_RESOURCE_CONFIG:
          case AuditLogType.INACTIVE_SHIFT_RESOURCE_CONFIG:
            newData = this._shiftResourceConfigurationToDomain(
              details.newData as AuditLogShiftResourceConfigurationDTO
            );
            oldData = this._shiftResourceConfigurationToDomain(
              details.oldData as AuditLogShiftResourceConfigurationDTO
            );
            break;
          case AuditLogType.ADD_SHIFT_RESOURCE:
          case AuditLogType.EDIT_SHIFT_RESOURCE:
          case AuditLogType.DELETE_SHIFT_RESOURCE:
            newData = this._shiftResourceActionToDomain(
              details.newData as AuditLogShiftResourceActionnDTO
            );
            oldData = this._shiftResourceActionToDomain(
              details.oldData as AuditLogShiftResourceActionnDTO
            );
            break;
        }
        break;
      case AuditLogModule.USER_MANAGEMENT:
        switch (event) {
          case AuditLogType.EDIT_USERS:
            newData = this._editUsersLogToDomain(
              details.newData as AuditLogEditUsersDTO
            );
            oldData = this._editUsersLogToDomain(
              details.oldData as AuditLogEditUsersDTO
            );
            break;
        }
        break;
      case AuditLogModule.SCHEDULE:
        switch (event) {
          case AuditLogType.EDIT_SCHEDULE_SHIFTS:
            newData = this._editScheduleShiftsLogToDomain(
              details.newData as AuditLogEditScheduleShiftsDTO
            );
            oldData = this._editScheduleShiftsLogToDomain(
              details.oldData as AuditLogEditScheduleShiftsDTO
            );
            break;
          case AuditLogType.RENAME_TEAM:
            newData = this._renameTeamLogToDomain(
              details.newData as AuditLogRenameTeamDTO
            );
            oldData = this._renameTeamLogToDomain(
              details.oldData as AuditLogRenameTeamDTO
            );
            break;
        }
        break;
      case AuditLogModule.SHIFT_MANAGEMENT:
        switch (event) {
          case AuditLogType.MANUAL_CLOSE_SHIFT:
            newData = this._manualCloseShiftLogToDomain(
              details.newData as AuditLogManualCloseShiftDTO
            );
            oldData = this._manualCloseShiftLogToDomain(
              details.oldData as AuditLogManualCloseShiftDTO
            );
            break;
        }
        break;
    }

    const auditLogDetails = {
      newData,
      oldData,
    };

    return {
      id: dto.id,
      module: module,
      details: auditLogDetails,
      event: dto.event,
      lastUpdatedBy: dto.lastUpdatedBy,
      lastUpdatedOn: dto.lastUpdatedOn,
    };
  }

  private _configurationDataSourcesAuditLogToDomain(
    dto: DataSourcesDetailsDTO
  ): DataSourcesDetails {
    return {
      id: dto?.id,
      dataSourceName: dto?.dataSourceName,
      dataSourceDes: dto?.dataSourceDes,
      dataType: dto?.dataType,
      values: dto?.values,
    };
  }

  private _configurationTaskAuditLogToDomain(dto: TaskDetailsDTO): TaskDetails {
    return {
      id: dto?.id,
      templateName: dto?.templateName,
      taskShift: dto?.taskShift,
      taskType: dto?.taskType,
      description: dto?.description,
      isRepeatable: dto?.isRepeatable,
      canAsNa: dto?.canAsNa,
      isAdhoc: dto?.isAdhoc,
    };
  }

  private _configurationAssetsAuditLogToDomain(
    dto: AssetAuditLogDetailsDTO
  ): AssetAuditLogDetails {
    const { assetType, fieldDefinitions } = dto || {};
    return {
      assetType: {
        id: assetType?.id,
        assetType: assetType?.assetType,
        description: assetType?.description,
        isRequiredReturn: assetType?.isRequiredReturn,
      },
      fieldDefinitions: (fieldDefinitions ?? [])
        .filter(field => field.inputFieldName !== 'Last Used By')
        .map(field =>
          this._configurationFieldDefinitionAuditLogToDomain(field)
        ),
    };
  }

  private _configurationFieldDefinitionAuditLogToDomain(
    dto: AuditLogFieldDefinitionDTO
  ): AuditLogFieldDefinition {
    let isActive = true;

    if (dto?.configType === 'Both')
      isActive = dto?.isCollectActive && dto?.isReturnActive;
    else if (dto?.configType === 'Collect') isActive = dto?.isCollectActive;
    else isActive = dto?.isReturnActive;

    return {
      isActive,
      id: dto?.id,
      inputFieldName: dto?.inputFieldName,
      inputFieldType: dto?.inputFieldType,
      dataSourceName: dto?.dataSourceName ?? 'N/A',
      isMandatory: dto?.isMandatory,
      children: dto?.children.map(child =>
        this._configurationFieldDefinitionAuditLogToDomain(child)
      ),
    };
  }

  private _configurationChangeStatusAssetAuditLogToDomain(
    dto: ChangeStatusAssetAuditDTO
  ): AssetAuditLogDetails {
    return {
      assetType: {
        id: dto?.id,
        assetType: dto?.name,
        description: dto?.description,
        isRequiredReturn: dto?.isRequiredReturn,
      },
      fieldDefinitions: [],
    };
  }

  private _configurationSectorAuditLogToDomain(
    dto: AuditLogSectorDetailsDTO
  ): AuditLogSectorDetails {
    const { sectorConfig } = dto ?? {};
    return {
      id: dto?.id,
      sectorName: dto?.sectorName,
      sectorType: dto?.sectorType,
      berthList: dto?.berthList,
      vesselType: sectorConfig?.vesselType,
      vesselTimingsToBeUpdated: sectorConfig?.vesselTimingsToBeUpdated,
    };
  }

  private _configurationGroupingAuditLogToDomain(
    dto: AuditLogSectorGroupingDetailsDTO
  ): AuditLogSectorGroupingDetails {
    return {
      sectorName: dto?.sectorName,
      groupType: dto?.groupType ?? dto?.taskGroupTypeName,
      addedTask: dto?.addedTask,
      dependencyTask: dto?.dependencyTask,
    };
  }

  private _configurationChatConfigurationsLogToDomain(
    dto: AuditLogChatConfigurationDTO
  ): AuditLogChatConfiguration {
    const { chatChannelConfig, chatConfig, sectors } = dto ?? {};

    return {
      chatChannelConfig:
        chatChannelConfig?.map(config => ({
          ...config,
          beforeETB: config.autoCreateConfig?.beforeETB ?? false,
          duration: config.autoCreateConfig?.duration ?? 0,
          itemsBerthGroupingChatGroup: config.itemsBerthGroupingChatGroup ?? [],
          itemsSectorChatGroup: config.itemsSectorChatGroup ?? [],
          itemsVesselChatGroup: config.itemsVesselChatGroup ?? [],
        })) ?? [],
      chatConfig: chatConfig ?? [],
      sectors: sectors ?? [],
    };
  }

  private _configurationCreateNewChatChannelLogToDomain(
    dto: AuditLogCreateNewChatChannelDTO
  ): AuditLogCreateNewChatChannel {
    const dtoValid = dto ?? {};

    return {
      [ChatConfigurationsFields.VESSEL]:
        dtoValid[ChatConfigurationsFields.VESSEL],
      [ChatConfigurationsFields.NON_VESSEL]:
        dtoValid[ChatConfigurationsFields.NON_VESSEL],
      [ChatConfigurationsFields.BERTH]:
        dtoValid[ChatConfigurationsFields.BERTH],
      [ChatConfigurationsFields.REMOVE_PARTICIPANTS_FROM_CHAT]:
        dtoValid[ChatConfigurationsFields.REMOVE_PARTICIPANTS_FROM_CHAT],
      [ChatConfigurationsFields.ARCHIVE]:
        dtoValid[ChatConfigurationsFields.ARCHIVE],
      [ChatConfigurationsFields.USER_MANAGEMENT]:
        dtoValid[ChatConfigurationsFields.USER_MANAGEMENT],
      [ChatConfigurationsFields.HIGH_PRIORITY_ALERTS]:
        dtoValid[ChatConfigurationsFields.HIGH_PRIORITY_ALERTS],
    };
  }

  private _configurationRosterLogToDomain(
    dto: AuditLogRosterDetailsDTO
  ): AuditLogRosterDetails {
    return {
      fileName: dto?.fileName,
      fileKey: dto?.fileKey,
    };
  }

  private _configurationAssetItemLogToDomain(
    dto: AuditLogAssetItemDetailsDTO
  ): AuditLogAssetItemDetails {
    const { stockConfigs } = dto ?? {};

    return {
      assetName: dto?.assetName,
      content: dto?.content,
      fieldDefinitions: dto?.fieldDefinitions,
      stockConfigs:
        stockConfigs?.map(config => ({
          id: config.id,
          isActive: config.isActive,
          conditionType: config.conditionType,
          inputName: config.inputName,
          inputType: config.inputType,
        })) || [],
    };
  }

  private _configurationSubTaskLogToDomain(
    dto: AuditLogSubTaskDTO
  ): AuditLogSubTask {
    return {
      id: dto?.id,
      dataSources: dto?.dataSources,
      subTaskName: dto?.subTaskName,
      subTaskDescription: dto?.subTaskDescription,
      isIncludeAttachmentsField: dto?.isIncludeAttachmentsField,
      isAttachmentsFieldOptional: dto?.isAttachmentsFieldOptional,
      isIncludeRemarksField: dto?.isIncludeRemarksField,
      isRemarksFieldOptional: dto?.isRemarksFieldOptional,
      taskTemplateName: dto?.taskTemplateName,
      taskTemplateId: dto?.taskTemplateId,
      completedByRoles: dto?.completedByRoles,
      isActive: dto?.isActive,
      elements:
        dto?.elements?.map(elem =>
          this._configurationSubTaskElementsLogToDomain(elem)
        ) ?? [],
    };
  }

  private _configurationSubTaskElementsLogToDomain(
    dto: AuditLogSubTaskElementDTO
  ): AuditLogSubTaskElement {
    return {
      id: dto?.id,
      hashWithChildren: dto?.hashWithChildren,
      hashWithOutChildren: dto?.hashWithOutChildren,
      index: dto?.index,
      levelDepth: dto?.levelDepth,
      properties: dto?.properties,
      type: dto?.type,
      setSetting: dto?.setSetting,
      children:
        dto?.children?.map(child =>
          this._configurationSubTaskElementsLogToDomain(child)
        ) ?? [],
    };
  }

  private _splitHash(hash: string): {
    hash: string;
    isUpdated: boolean;
  } {
    const [hashKey, updatedKey] = hash.split('-');

    return {
      hash: hashKey ?? hash,
      isUpdated: !!updatedKey,
    };
  }

  private _configurationEmailNotificationLogToDomain(
    dto: AuditLogEmailNotificationDTO
  ): AuditLogEmailNotification {
    const { alertTo, targetObject, notificationType } = dto ?? {};

    return {
      id: dto?.id,
      notificationType: notificationType,
      name: dto?.name,
      trigger: dto?.trigger,
      shiftType: dto?.shiftType,
      alertTo: [...(alertTo?.targetRoles ?? []), ...(alertTo?.emails ?? [])],
      alertType: dto?.alertType,
      correspondingTask:
        notificationType === EmailNotificationTypeEnum.TASK
          ? targetObject?.name
          : undefined,
      correspondingAsset:
        notificationType === EmailNotificationTypeEnum.ASSET
          ? targetObject?.name
          : undefined,
      alertHeader: dto?.alertHeader,
      alertContent: dto?.alertContent,
    };
  }

  private _configurationApprovalRuleLogToDomain(
    dto: AuditLogTaskApprovalRuleDTO
  ): AuditLogTaskApprovalRule {
    const { taskConfig } = dto ?? {};

    return {
      id: dto?.id,
      ruleName: dto?.ruleName,
      trigger: taskConfig?.trigger,
      shiftType: taskConfig?.shiftType,
      approvalLevels: taskConfig?.approvalLevels,
      tasks: dto?.tasks.map(task => task.taskName),
    };
  }

  private _configurationChatNotificationLogToDomain(
    dto: AuditLogChatNotificationDTO
  ): AuditLogChatNotification {
    const { targetObject, notificationType } = dto ?? {};

    return {
      id: dto?.id,
      notificationType: notificationType,
      name: dto?.name,
      trigger: dto?.trigger,
      publishToChat: dto?.publishToChat.name,
      correspondingTask:
        notificationType === EmailNotificationTypeEnum.TASK
          ? targetObject?.name
          : undefined,
      correspondingAsset:
        notificationType === EmailNotificationTypeEnum.ASSET
          ? targetObject?.name
          : undefined,
      alertContent: dto?.alertContent,
    };
  }

  private _userAssignPersonnelToDomain(
    dto: AssignPersonnelAuditLogDTO
  ): AssignPersonnelAuditLog {
    const { personnel } = dto ?? {};

    return {
      sectorName: dto?.sectorName,
      assignedTo: this._personnelAuditLogToDomain(personnel),
    };
  }

  private _personnelAuditLogToDomain(
    dto: PersonnelAuditLogDTO[]
  ): PersonnelAuditLog[] {
    if (!dto?.length) return [];

    return dto.map(personnel => ({
      id: personnel.id,
      employeeNo: personnel?.employeeNo,
      username: personnel?.username,
    }));
  }

  private _userSaveAsDraftTaskLogToDomain(
    dto: SaveAsDraftTaskAuditLogDTO
  ): SaveAsDraftTaskAuditLog {
    const { assignedTo, subTasks } = dto ?? {};

    return {
      status: dto?.status,
      subTasks: this._taskAssignSubTasksToDomain(subTasks ?? []),
      grouping: dto?.grouping,
      taskName: dto?.taskName,
      taskType: dto?.taskType,
      shiftType: dto?.shiftType,
      assignedTo:
        assignedTo?.map(personnel => ({
          employeeNo: personnel.employeeNo,
          id: personnel.id,
          username: personnel.username,
        })) ?? [],
      vesselDetail: dto?.vesselDetail,
    };
  }

  private _taskAssignSubTasksToDomain(
    dtos: TaskAssignSubTaskDTO[]
  ): TaskAssignSubTask[] {
    return dtos.map(dto => {
      const { answers, subtaskDetail } = dto;
      return {
        answers,
        subtaskDetail: {
          dataSources: subtaskDetail?.dataSources,
          elements: subtaskDetail?.elements,
          subTaskName: subtaskDetail?.subTaskName,
          taskTemplateName: subtaskDetail?.taskTemplateName,
        },
      };
    });
  }

  private _duplicateTaskLogToDomain(
    dto: DuplicateTaskAuditLogDTO
  ): DuplicateTaskAuditLog {
    return {
      sectorName: dto?.grouping,
      taskName: dto?.taskName,
      reason: dto?.reason,
    };
  }

  private _authenticationLogInToDomain(
    dto: AuthenticationLogInAuditLogDTO,
    roles: string[],
    username: string
  ): AuthenticationLogInAuditLog {
    return {
      username,
      ipAddress: dto?.ipAddress,
      loginStatus: dto?.loginStatus,
      roles,
    };
  }

  private _handoverRemarksLogToDomain(
    dto: HandoverRemarksAuditLogDTO
  ): HandoverRemarksAuditLog {
    return {
      taskName: dto?.taskName,
      sectorName: dto?.sectorName,
      vesselName: dto?.vesselName,
      remarks: dto?.remarks,
    };
  }

  private _attendanceTakingLogToDomain(
    dto: AttendanceTakingAuditLogDTO
  ): AttendanceTakingAuditLog {
    return {
      personnelName: dto?.personnelName,
    };
  }

  private _assignAdHocTaskLogToDomain(
    dto: AssignAdHocTaskAuditLogDTO
  ): AssignAdHocTaskAuditLog {
    return {
      sectorName: dto?.sectorName,
      templates: dto?.templates,
    };
  }

  private _pendingForApprovalLogToDomain(
    dto: PendingForApprovalNAAuditLogDTO
  ): PendingForApprovalNAAuditLog {
    return {
      shiftType: dto?.shiftType,
      taskType: dto?.taskType,
      assignedTo: dto?.assignedTo,
      grouping: dto?.grouping,
      status: dto?.status,
      taskName: dto?.taskName,
      vesselDetail: dto?.vesselDetail,
    };
  }

  private _otPersonnelToDomain(
    dto: AuditLogOTPersonnelDTO
  ): AuditLogOTPersonnel {
    return {
      select: dto?.select ?? [],
      unselect: dto?.unselect ?? [],
    };
  }

  private _reportAuditLogToDomain(dto: ReportAuditLogDTO): ReportAuditLog {
    return {
      reportName: dto?.reportName,
    };
  }

  private _closeVesselToDomain(
    dto: CloseVesselAuditLogDTO
  ): CloseVesselAuditLog {
    return {
      berth: dto?.berth,
      closedAt: dto?.closedAt,
      closedByUser: dto?.closedByUser,
      closedByUserId: dto?.closedByUserId,
      grouping: dto?.grouping,
      shiftType: dto?.shiftType,
      vesselByShiftId: dto?.vesselByShiftId,
      vesselName: dto?.vesselName,
    };
  }

  private _hotoTemplateToDomain(
    dto: HotoTemplateAuditLogDTO
  ): HotoTemplateAuditLog {
    return {
      id: dto?.id,
      isActive: dto?.isActive,
      metadata: dto?.metadata,
      configCode: dto?.configCode,
      configName: dto?.configName,
      moduleType: dto?.moduleType,
      description: dto?.description,
      displayOrder: dto?.displayOrder,
      elements:
        dto?.elements?.map(elem =>
          this._configurationSubTaskElementsLogToDomain(elem)
        ) ?? [],
      dataSources: dto?.dataSources ?? [],
    };
  }

  private _vesselActivityConfigurationToDomain(
    dto: VesselActivityConfigurationAuditLogDTO
  ): VesselActivityConfigurationAuditLog {
    return {
      id: dto?.id,
      isActive: dto?.isActive,
      metadata: dto?.metadata,
      configCode: dto?.configCode,
      configName: dto?.configName,
      moduleType: dto?.moduleType,
      description: dto?.description,
      displayOrder: dto?.displayOrder,
      elements:
        dto?.elements?.map(element =>
          this._configurationSubTaskElementsLogToDomain(element)
        ) ?? [],
      dataSources: dto?.dataSources ?? [],
      applicabilities: dto?.applicabilities ?? [],
      createdBy: dto?.createdBy,
      createdAt: dto?.createdAt,
      updatedBy: dto?.updatedBy,
      updatedAt: dto?.updatedAt,
      updatedByName: dto?.updatedByName,
    };
  }

  private _shiftResourceConfigurationToDomain(
    dto: AuditLogShiftResourceConfigurationDTO
  ): AuditLogShiftResourceConfigurationDetails {
    return {
      id: dto?.id,
      configName: dto?.configName,
      description: dto?.description,
      elements: dto?.elements,
      dataSources: dto?.dataSources,
      applicabilities: dto?.applicabilities,
    };
  }

  private _shiftResourceActionToDomain(
    dto: AuditLogShiftResourceActionnDTO
  ): AuditLogShiftResourceActionDetails {
    return {
      id: dto?.id,
      status: dto?.status,
      configId: dto?.configId,
      formData: dto?.formData,
      shiftId: dto?.shiftId,
    };
  }

  private _vesselActivityActionToDomain(
    dto: AuditLogVesselActivityActionDTO
  ): AuditLogVesselActivityActionDetails {
    return {
      id: dto?.id,
      status: dto?.status,
      configId: dto?.configId,
      formData: dto?.formData,
      vesselByShiftId: dto?.vesselByShiftId,
    };
  }

  private _editUsersLogToDomain(
    dto: AuditLogEditUsersDTO
  ): AuditLogEditUsersDetails {
    return {
      users: (dto?.users ?? []).map(user => this._editUserItemToDomain(user)),
    };
  }

  private _editUserItemToDomain(user: {
    employeeNo: string;
    userName: string;
    teamName: string | null;
    ertType: string | null;
    isActive: boolean;
  }): AuditLogEditUserItem {
    return {
      employeeNo: user?.employeeNo,
      userName: user?.userName,
      teamName: user?.teamName,
      ertType: user?.ertType,
      isActive: user?.isActive,
    };
  }

  private _editScheduleShiftsLogToDomain(
    dto: AuditLogEditScheduleShiftsDTO
  ): AuditLogEditScheduleShiftsDetails {
    return {
      shifts: (dto?.shifts ?? []).map(shift =>
        this._scheduleShiftItemToDomain(shift)
      ),
    };
  }

  private _scheduleShiftItemToDomain(
    dto: AuditLogScheduleShiftItemDTO
  ): AuditLogScheduleShiftItem {
    return {
      id: dto?.id,
      date: dto?.date,
      teamKey: dto?.teamKey,
      teamName: dto?.teamName,
      shiftType: dto?.shiftType,
    };
  }

  private _renameTeamLogToDomain(
    dto: AuditLogRenameTeamDTO
  ): AuditLogRenameTeamDetails {
    return {
      teams: (dto?.teams ?? []).map(team => this._renameTeamItemToDomain(team)),
    };
  }

  private _renameTeamItemToDomain(
    dto: AuditLogRenameTeamItemDTO
  ): AuditLogRenameTeamItem {
    return {
      key: dto?.key,
      name: dto?.name,
    };
  }

  private _manualCloseShiftLogToDomain(
    dto: AuditLogManualCloseShiftDTO
  ): AuditLogManualCloseShiftDetails {
    return {
      shiftId: dto?.shiftId,
      closedAt: dto?.closedAt,
      closedBy: dto?.closedBy,
      shiftType: dto?.shiftType,
      closureType: dto?.closureType,
      closedByUserId: dto?.closedByUserId,
    };
  }
}
